import React from "react";
import PropTypes from "prop-types";

function LightButton(Props) {
     const { title } = Props;
    return <>
        <button className="light_btn">{title}</button>
    </>
}

LightButton.propTypes = {
  title: PropTypes.string
};

LightButton.defaultProps = {
  title: "Please enter Button Title"
};


export default LightButton